import type { ContentElementCompanyLogos as ContentElementCompanyLogosType } from '@src/lib/graphql/generated';
import { ContentElementCompanyLogos as CeCompanyLogos } from '@vgn-medien-holding/vgn-fe-components';
import companyLogoStyle from '../ContentElementCompanyLogo/styles/default';
import defaultStyle from './styles/default';

export default function ContentElementCompanyLogos(element: ContentElementCompanyLogosType) {
  return <CeCompanyLogos element={element} classProps={defaultStyle} companyLogoClassProps={companyLogoStyle} />;
}
